/**
 * CRO-WEB-182 Experiment Configuration
 *
 * Configuration for the payment success countdown redirect experiment.
 * Control: Show normal "Get cooking" button that requires user click
 * Variant: Show countdown timer with circular indicator that auto-redirects to /premium/app after 3 seconds
 */

import type { ExperimentConfig } from "@/src/experiments/useExperimentTracking";
import { getCroWeb182Variant } from "./getCroWeb182Variant";

export const croWeb182Config: ExperimentConfig = {
  name: "cro-web-182",
  getVariant: getCroWeb182Variant,
  eventName: "cro_web_182_experiment_participation",
  featureFlagName: "cro-web-182",
  variants: ["control", "test"],
};
